import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { routeConfig } from "./routes";
import { registerProjects } from "./registerProject";
import {
  vsName as ProjectDetailComponentName,
  projectDetailComponentOptions,
} from "./views/info";

import {
  vsComponentName as projectDetailMachineComponentName,
  projectDetailMachineComponentOptions,
} from "./views/info/machines";

import { moduleName as recordsModuleName } from "../records";
import {
  ProjectCostServiceProvider,
  vsProviderName as ProjectCostServiceProviderName,
} from "./shared/ProjectCostService";
import { vsModuleName as SharedProjectCostModule } from "./shared";

import { vsModuleName as shareMachinesModuleName } from "../machines/shared";

export const vsName = "SlotTrak.ProjectCost";

angular
  .module(vsName, [
    uiRouter,
    recordsModuleName,
    SharedProjectCostModule,
    shareMachinesModuleName,
  ])
  .config(routeConfig)
  .config(registerProjects)
  .provider(ProjectCostServiceProviderName, ProjectCostServiceProvider)
  .component(ProjectDetailComponentName, projectDetailComponentOptions)
  .component(
    projectDetailMachineComponentName,
    projectDetailMachineComponentOptions
  );

export default vsName;
